import { useEffect } from 'react';

const SITEMAP_EDGE_FUNCTION_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/sitemap`;

export default function Sitemap() {
  useEffect(() => {
    // Redirect to the edge function that generates the sitemap
    window.location.replace(SITEMAP_EDGE_FUNCTION_URL);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">מעביר ל-Sitemap...</p>
      </div>
    </div>
  );
}
